var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterFooter = function SvgTwitterFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    strokeOpacity: 0.2,
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.556 9a8.5 8.5 0 0 1-2.443 1.19A3.484 3.484 0 0 0 16 12.523v.778a8.29 8.29 0 0 1-7-3.523s-3.111 7 3.889 10.11a9.05 9.05 0 0 1-5.445 1.556c7 3.89 15.556 0 15.556-8.944q-.001-.326-.062-.646A6 6 0 0 0 24.555 9"
  })));
};
export default SvgTwitterFooter;